// language=GraphQL
export const ALL_DATE_SWITCH_SETTINGS_QUERY = `query Query {
  dateSwitchSettings: allTravelServiceDateSwitchSettings {
    id
    startDateOffsetDays
    endDateOffsetDays
  }
}`

// language=GraphQL
export const SINGLE_DATE_SWITCH_SETTINGS_QUERY = `query Query($id: ID!) {
  dateSwitchSettings: travelServiceDateSwitchSettings(id: $id) {
    id
    startDateOffsetDays
    endDateOffsetDays
  }
}`

// language=GraphQL
export const CREATE_DATE_SWITCH_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelServiceDateSwitchSettingsInput) {
    dateSwitchSettings: createTravelServiceDateSwitchSettings(input: $input) {
      id
      startDateOffsetDays
      endDateOffsetDays
    }
  }`

// language=GraphQL
export const UPDATE_DATE_SWITCH_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelServiceDateSwitchSettingsInput) {
    dateSwitchSettings: updateTravelServiceDateSwitchSettings(input: $input) {
      id
      startDateOffsetDays
      endDateOffsetDays
    }
  }`

// language=GraphQL
export const DELETE_DATE_SWITCH_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelServiceDateSwitchSettingsInput) {
    deleteTravelServiceDateSwitchSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_DATE_SWITCH_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelServiceDateSwitchSettingsInput) {
    forceDeleteTravelServiceDateSwitchSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const DATE_SWITCH_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingMandatorySettings: Boolean = false) {
  groupedDependents: travelServiceDateSwitchSettingsDependents(id: $id) {
    travelPricingMandatorySettings @include(if: $withTravelPricingMandatorySettings) {
      id
      isMandatory
      useRules
      useDateSwitch
      useBusSettings
    }
  }
}`
